import React, {memo} from "react";

const FilterBarHeader = memo(({selectedCity, handleDropdownActive, zipCode, city}) => {
    return (
        <div
            className={`dp__header__filter-bar__location-store__store ${selectedCity !== '' ? "selected" : "no-selected"}`}>
            <button
                onMouseOver={(event) => handleDropdownActive(event, "storeActive")}>{selectedCity === "" ? "Vérifier les disponibilités" :
                city + " - " + zipCode}</button>
        </div>
    )
})
export default FilterBarHeader;